import {Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel,} from '@material-ui/core';
import {FormattedMessage} from 'react-intl';
import Required from './Required';

export default ({label, ...props}) => (
  <FormControl error={!!props.errors?.[props.name]} component="fieldset">
    <FormControlLabel
      control={<Checkbox {...props} color="primary"/>}
      label={<FormLabel component="legend"><FormattedMessage {...label} />{props.required && <Required/>}</FormLabel>}/>
    {!!props.errors?.[props.name] && (<FormHelperText>{props.errors?.[props.name]}</FormHelperText>)}
  </FormControl>
);
